import ColorPickerEditor from './ColorPickerEditor';

export default ColorPickerEditor;
